import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Loading } from 'ui-components/loading/loading-component';
import { useSelector } from 'react-redux';
import { anonymousUserPermissionsSelector } from 'store/selectors/app-selectors';

const useAnonymousPermissionsAvailable = () => {
    const anonymousUserPermissions = useSelector(anonymousUserPermissionsSelector);
    const [render, setRender] = useState<boolean>(!!anonymousUserPermissions);

    useEffect(() => {
        if (anonymousUserPermissions && !render) {
            setRender(true);
        }
    }, [anonymousUserPermissions, render]);

    return render;
};

export const AnonymousPermissionsManager = ({ children }: PropsWithChildren<{}>) => {
    const render = useAnonymousPermissionsAvailable();

    return (
        <Loading show={!render} className="pl-route-loader">
            <>{children}</>
        </Loading>
    );
};
